import React, { useEffect, useState } from "react";
import SingleJobCard from "../../../components/items/SingleJobCard";
import Companylogo1 from "../../../assets/images/front/image1.webp";
import Companylogo2 from "../../../assets/images/front/image2.webp";
import Companylogo3 from "../../../assets/images/front/image3.webp";
import Companylogo4 from "../../../assets/images/front/image4.webp";
import Companylogo5 from "../../../assets/images/front/image5.webp";
import Button from "../../form/front/Button";
import Select from "../../form/front/Select";
import SearchWithDropdown from "../../form/front/SearchWithDropdown";
import { useQuery } from "@tanstack/react-query";
import { jobDetailsUser, jobUserList } from "../../../services/postService";

const JobSection = () => {
  const [selectSort, setSelectSort] = useState(null);
  const [experience, setExperience] = useState(null);
  const [companyType, setCompanyType] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [salary, setSalary] = useState(null);
  const [skills, setSkills] = useState(null);
  /* ---------------- JOB SEARCH STATE ---------------- */
  const [keyword, setKeyword] = useState("");
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  /* ---------------- COUNTRY / STATE SEARCH STATE ---------------- */
  const [countryKeyword, setCountryKeyword] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  /* ---------------- STATIC JOB SEARCH DATA ---------------- */
  const searchJobsData = [
    {
      _id: "1",
      type: "list",
      name: "Frontend Developer",
      icon: "fa-regular fa-briefcase",
    },
    {
      _id: "2",
      type: "list",
      name: "Backend Developer",
      icon: "fa-regular fa-briefcase",
    },
    {
      _id: "3",
      type: "list",
      name: "React Developer",
      icon: "fa-regular fa-briefcase",
    },
    {
      _id: "4",
      type: "list",
      name: "UI/UX Designer",
      icon: "fa-regular fa-palette",
    },
    {
      _id: "5",
      type: "list",
      name: "Product Manager",
      icon: "fa-regular fa-diagram-project",
    },
  ];

  /* ---------------- STATIC COUNTRY / STATE DATA ---------------- */
  const countryStateData = [
    { _id: "c1", type: "list", name: "India" },
    { _id: "c2", type: "list", name: "United States" },
    { _id: "c3", type: "list", name: "United Kingdom" },
    { _id: "c4", type: "list", name: "Canada" },
    { _id: "c5", type: "list", name: "Australia" },
    { _id: "c6", type: "list", name: "California, USA" },
    { _id: "c7", type: "list", name: "New York, USA" },
    { _id: "c8", type: "list", name: "Maharashtra, India" },
    { _id: "c9", type: "list", name: "Karnataka, India" },
  ];
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "job-list",
      { keyword, experience, companyType, jobType, salary, skills },
    ],
    queryFn: () =>
      jobUserList({
        sortQuery: "-createdAt",
        // ...(keyword && { search: keyword }),
        // ...(experience && { experience }),
        // ...(companyType && { companyType }),
        // ...(jobType && { jobType }),
        // ...(salary && { salary }),
        // ...(skills && { skills }),
      }),
    keepPreviousData: true,
  });

  const jobsData = data?.docs?.data || [];
  useEffect(() => {
    if (jobsData.length > 0 && !selectedJob) {
      setSelectedJob(jobsData[0]);
      setKeyword(jobsData[0].content?.en?.title || "");
    }
  }, [jobsData]);
  /* ---------------- SELECTED JOB DETAILS ---------------- */
  const { data: jobDetails, isLoading: isDetailsLoading } = useQuery({
    queryKey: ["job-details", selectedJob?.slug],
    queryFn: async () => {
      if (!selectedJob?.slug) return null;
      const res = await jobDetailsUser({ id: selectedJob.slug });
      return res;
    },
    enabled: !!selectedJob?.slug, // fetch only when a job is selected
  });
  /* ---------------- JOB FILTER LOGIC ---------------- */
  useEffect(() => {
    if (!keyword) {
      setFilteredJobs([]);
      return;
    }

    const filtered = searchJobsData.filter((job) =>
      job.name.toLowerCase().includes(keyword.toLowerCase()),
    );

    setFilteredJobs(filtered);
  }, [keyword]);

  /* ---------------- COUNTRY FILTER LOGIC ---------------- */
  useEffect(() => {
    if (!countryKeyword) {
      setFilteredCountries([]);
      return;
    }

    const filtered = countryStateData.filter((item) =>
      item.name.toLowerCase().includes(countryKeyword.toLowerCase()),
    );

    setFilteredCountries(filtered);
  }, [countryKeyword]);

  const handleJobSelect = (job) => {
    setSelectedJob(job);
    setKeyword(job?.content?.en?.title || "");
  };

  const handleCountrySelect = (item) => {
    setSelectedCountry(item);
    setCountryKeyword(item?.name || "");
  };

  const sortOptions = [
    { value: "lastupdate", name: "Last Update" },
    { value: "latest", name: "Latest" },
  ];

  const experienceOptions = [
    { value: "fresher", name: "Fresher (0–1 yr)" },
    { value: "junior", name: "Junior (1–3 yrs)" },
    { value: "mid", name: "Mid Level (3–5 yrs)" },
    { value: "senior", name: "Senior (5+ yrs)" },
  ];

  const companyTypeOptions = [
    { value: "startup", name: "Startup" },
    { value: "product", name: "Product Based" },
    { value: "service", name: "Service Based" },
    { value: "enterprise", name: "Enterprise" },
  ];

  const jobTypeOptions = [
    { value: "fulltime", name: "Full Time" },
    { value: "parttime", name: "Part Time" },
    { value: "contract", name: "Contract" },
    { value: "internship", name: "Internship" },
    { value: "freelance", name: "Freelance" },
  ];

  const salaryOptions = [
    { value: "0-3", name: "$0 – ₹3 LPA" },
    { value: "3-6", name: "$3 – ₹6 LPA" },
    { value: "6-10", name: "$6 – ₹10 LPA" },
    { value: "10+", name: "$10+ LPA" },
  ];

  const skillOptions = [
    { value: "react", name: "React" },
    { value: "node", name: "Node.js" },
    { value: "uiux", name: "UI/UX Design" },
    { value: "python", name: "Python" },
    { value: "aws", name: "AWS / Cloud" },
  ];

  return (
    <section className="pt-5 pb-10 md:pb-14 xls:pb-28 bg-white relative w-full px-4 sm:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto rounded-t-3xl -mt-40">
      <div className="px-0 md:px-7 py-4 md:py-7 space-y-4">
        <div className="relative shadow-md rounded-lg py-3 flex flex-col md:flex-row justify-between items-center gap-x-4 border border-slate-200 px-2 md:px-4 divide-y md:divide-y-0 divide-slate-200">
          <div className="flex-shrink flex-grow w-full  md:border-r border-slate-300">
            <SearchWithDropdown
              placeholder="Search jobs"
              dropdownData={filteredJobs}
              keyword={keyword}
              setKeyword={setKeyword}
              onChange={handleJobSelect}
              xPlacement="bottom"
              dropdownClass="bg-white rounded"
              divClasses="border-0"
              inputClasses="pr-24"
              icon="fa-light fa-search"
              iconClasses="text-black text-lg md:text-2xl"
            />
          </div>

          <div className="flex-shrink flex-grow w-full">
            <SearchWithDropdown
              placeholder="Country or state"
              dropdownData={filteredCountries}
              keyword={countryKeyword}
              setKeyword={setCountryKeyword}
              onChange={handleCountrySelect}
              xPlacement="bottom"
              dropdownClass="bg-white rounded"
              divClasses="border-0"
              inputClasses="pr-0 md:pr-24"
              icon="fa-light fa-location-dot"
              iconClasses="text-black text-lg md:text-2xl"
            />
          </div>

          <div className="relative md:absolute right-0 md:right-4 w-full md:w-auto">
            <Button
              buttonLabel="Search"
              buttonLabelClasses="text-base md:text-xl group-hover:text-palatte"
              buttonClasses="w-full md:w-auto h-10 md:h-14 rounded bg-palatte px-7 border border-palatte hover:bg-transparent group"
            />
          </div>
        </div>

        <div className="flex gap-3 flex-wrap">
          <div className="flex-shrink flex-grow w-full sm:w-auto">
            <Select
              placeholder="Experience Level"
              dropdownData={experienceOptions}
              selectedValue={experience}
              onChange={(value) => setExperience(value)}
              xPlacement="bottom-right"
              dropdownClass="bg-white w-full"
              dropdownButtonClass="shadow-sm"
            />
          </div>

          <div className="flex-shrink flex-grow w-full sm:w-auto">
            <Select
              placeholder="Company Type"
              dropdownData={companyTypeOptions}
              selectedValue={companyType}
              onChange={(value) => setCompanyType(value)}
              xPlacement="bottom-right"
              dropdownClass="bg-white w-full"
              dropdownButtonClass="shadow-sm"
            />
          </div>

          <div className="flex-shrink flex-grow w-full sm:w-auto">
            <Select
              placeholder="Job Type"
              dropdownData={jobTypeOptions}
              selectedValue={jobType}
              onChange={(value) => setJobType(value)}
              xPlacement="bottom-right"
              dropdownClass="bg-white w-full"
              dropdownButtonClass="shadow-sm"
            />
          </div>

          <div className="flex-shrink flex-grow w-full sm:w-auto">
            <Select
              placeholder="Salary"
              dropdownData={salaryOptions}
              selectedValue={salary}
              onChange={(value) => setSalary(value)}
              xPlacement="bottom-right"
              dropdownClass="bg-white w-full"
              dropdownButtonClass="shadow-sm"
            />
          </div>

          <div className="flex-shrink flex-grow w-full sm:w-auto">
            <Select
              placeholder="Skills"
              dropdownData={skillOptions}
              selectedValue={skills}
              onChange={(value) => setSkills(value)}
              xPlacement="bottom-right"
              dropdownClass="bg-white w-full"
              dropdownButtonClass="shadow-sm"
            />
          </div>
        </div>
      </div>

      {/* ---------------- CONTENT GRID ---------------- */}
      <div className="grid grid-cols-1 xls:grid-cols-2 gap-8">
        <div className="space-y-5">
          <div className="flex flex-col md:flex-row items-start gap-2 md:items-center justify-between">
            <div className="flex-shrink flex-grow">
              <span className="text-black text-xl font-bold">
                Recommended jobs:{" "}
              </span>
              <span className="text-xl text-gray-400">
                {jobsData?.length || 0}
              </span>
            </div>
            <div className="flex-shrink-0 flex-grow-0">
              <div className="flex items-center gap-2 justify-end">
                <div className="flex-shrink flex-grow text-black text-base ">
                  Sort by:
                </div>
                <div className="flex-shrink-0 flex-grow-0">
                  <Select
                    placeholder="Last Update"
                    dropdownData={sortOptions}
                    selectedValue={selectSort}
                    onChange={(value, item) => {
                      setSelectSort(value);
                    }}
                    xPlacement="bottom-right"
                    dropdownClass="bg-white"
                    dropdownButtonClass="w-36"
                  />
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div>Loading jobs...</div>
          ) : isError ? (
            <div>Error loading jobs: {error.message}</div>
          ) : jobsData.length === 0 ? (
            <div>No jobs found.</div>
          ) : (
            jobsData.map((job) => (
              <SingleJobCard
                key={job._id}
                data={{
                  id: job._id,
                  slug: job.slug,
                  image: job.organization?.logo?.url,
                  title: job.content?.en?.title,
                  subtitle: job.organization?.content?.en?.title,
                  description: job?.organization?.content?.en?.content,
                  jobType: job.job?.jobType,
                  workMode: job.locationType,
                }}
                onClick={handleJobSelect}
                isSelected={selectedJob?._id === job._id}
              />
            ))
          )}
        </div>

        <div className="px-4 md:px-7 py-4 md:py-7 border border-slate-200 rounded-xl md:rounded-3xl overflow-hidden">
          {isDetailsLoading ? (
            <div>Loading job details...</div>
          ) : !jobDetails?.data ? (
            <div>No job details available.</div>
          ) : (
            <>
              <div className="flex items-center justify-between">
                <div className="flex-shrink flex-grow space-y-1">
                  <div className="text-xl md:text-2xl text-black capitalize font-bold">
                    {jobDetails.data.content?.en?.title || "Untitled Job"}
                  </div>
                  <div className="text-sm md:text-base text-slate-500 font-medium">
                    {jobDetails.data.organization?.content?.en?.title ||
                      "Unknown Company"}
                  </div>
                  <div className="text-sm md:text-base text-slate-500 space-y-1">
                    {jobDetails.data.organization?.content?.en?.content || ""}
                  </div>
                </div>
              </div>

              <div className="space-y-1 mt-5">
                <div className="flex items-center gap-4">
                  <div className="text-palatte5 text-lg">
                    <i className="fa-solid fa-briefcase"></i>
                  </div>
                  <div className="flex-grow text-slate-500 font-medium text-sm md:text-base">
                    {[
                      jobDetails?.data?.job?.jobType,
                      jobDetails?.data?.job?.experience?.content?.en?.title,
                    ]
                      .filter(Boolean)
                      .map((str) =>
                        str
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1),
                          )
                          .join(" "),
                      )
                      .join(" - ") || "N/A"}
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-palatte5 text-lg">
                    <i className="fa-solid fa-building"></i>
                  </div>
                  <div className="flex-grow text-slate-500 font-medium text-sm md:text-base">
                    {jobDetails.data.organization?.businessInfo?.employeeCount
                      ? `${jobDetails.data.organization.businessInfo.employeeCount} employees`
                      : "Employee count not specified"}
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-palatte5 text-lg">
                    {/* <i className="fa-solid fa-indian-rupee-sign"></i> */}
                    <i className="fa-solid fa-briefcase"></i>
                  </div>
                  <div className="flex-grow text-slate-500 font-medium text-sm md:text-base">
                    {jobDetails.data.job?.skills
                      ?.map((s) => s.content?.en?.title)
                      .filter(Boolean)
                      .join(", ") || "N/A"}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-2 mt-5 flex-wrap">
                <Button
                  buttonLabel={"Apply Now"}
                  buttonLabelClasses="text-sm text-white capitalize group-hover:text-palatte"
                  buttonClasses="bg-palatte h-10 rounded px-4 hover:bg-transparent border border-palatte group hover:text-palatte"
                />
                <Button
                  buttonLabel={"Save job"}
                  buttonIconPosition="right"
                  buttonIcon={"fa-regular fa-bookmark"}
                  buttonLabelClasses="text-sm text-white capitalize group-hover:text-palatte4"
                  buttonClasses="bg-palatte4 h-10 rounded px-4 hover:bg-transparent border border-palatte4 group hover:text-palatte4"
                />
                <Button
                  buttonLabel={"Share"}
                  buttonIconPosition="right"
                  buttonIcon={"fa-solid fa-share"}
                  buttonLabelClasses="text-sm text-white capitalize group-hover:text-palatte6"
                  buttonClasses="bg-palatte6 h-10 rounded px-4 hover:bg-transparent border border-palatte6 group hover:text-palatte6"
                />
              </div>

              <div className="space-y-3 mt-5">
                <div className="mt-4 space-y-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: jobDetails.data.content?.en?.content || "",
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default JobSection;
